import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import qs from 'query-string';

import ga from '~/utils/ga';
import bridge from '~/utils/bridge';
import copy from '~/utils/copy-text';

import useAuth from '~/hooks/useAuth';

import BG from '~/components/background';

import gangnam from './images/result_gangnam.png';
import gwacheon from './images/result_gwacheon.png';
import namyangju from './images/result_namyangju.png';
import sejong from './images/result_sejong.png';
import suwon from './images/result_suwon.png';
import sillim from './images/result_sillim.png';
import yangyang from './images/result_yangyang.png';
import yeosu from './images/result_yeosu.png';
import yeouido from './images/result_yeouido.png';
import yongin from './images/result_yongin.png';
import incheon from './images/result_incheon.png';
import jeju from './images/result_jeju.png';
import cheonan from './images/result_cheonan.png';
import pajuh from './images/result_pajuh.png';
import haeundae from './images/result_haeundae.png';
import hongdae from './images/result_hongdae.png';

import { ResultWrap } from './styled';

function ResultComponent() {
  const { search } = useLocation();
  const parse = qs.parse(search);
  const type = parse?.type ?? '';

  const { authKey } = useAuth();

  useEffect(() => {
    window.Kakao.init('7b905539e95a55efabd3ba6320ba6bae');
  }, []);

  function clickSearchRoom() {
    ga('다방마불', '매물 보러 가기', '매물 보러 가기');

    if (['gangnam', 'sillim', 'hongdae', 'yeouido', 'haeundae'].includes(type)) {
      let params = {
        api_type: 'REGION',
        id: '',
        zoom: 14,
      };
  
      if (type === 'gangnam') {
        params.id = '11680';
      } else if (type === 'sillim') {
        params.id = '11620';
      } else if (type === 'hongdae') {
        params.id = '11';
      } else if (type === 'yeouido') {
        params.id = '11560';
      } else if (type === 'haeundae') {
        params.id = '26';
      }

      bridge.web(() => {
        window.location.href = 'dabang://map';
      });

      bridge.android(call => {
        console.log('android');
        call.signRoomList(JSON.stringify(params));
      });
  
      bridge.ios(call => {
        call.callHandler('ObjC Echo', {
          cmd: 'signRoomList',
          params: params,
        });
      });

    } else {
      bridge.web(() => {
        window.location.href = 'dabang://map';
      });

      bridge.android(call => {
        console.log('android');
        call.openBrowser('dabang://map');
      });
  
      bridge.ios(call => {
        call.callHandler('ObjC Echo', {
          cmd: 'openBrowser',
          url: 'dabang://map',
        });
      });
    }
  }

  function sendLink() {
    window.Kakao.Link.sendDefault({
      objectType: 'feed',
      content: {
        title: '다방 이벤트',
        imageUrl:`https://static.dabangapp.com/img/dabangmarble/share_${type}.png`,
        link: {
          webUrl: window.location.href,
          mobileWebUrl: window.location.href,
        },
        description: '다방X부루마불 내 자취방 동네 찾기',
      },
      installTalk: true,
    });
    ga('다방마불', '공유', '카카오톡 공유');
  }

  function clickCopy() {
    ga('다방마불', '공유', '링크공유');
    alert('URL이 복사되었습니다.');
    copy(window.location.href);
  }

  function clickReTry() {
    if (authKey) {
      window.location.replace(`/2022/04/dbti/?auth_key=${authKey}`);
    } else {
      window.location.href = 'https://dabang.page.link/9Vrq';
    }
  }

  return (
    <ResultWrap>
      {
        type === 'gangnam' ? <BG width={710} height={2528} imgUrl={gangnam} /> :
        type === 'gwacheon' ? <BG width={710} height={2528} imgUrl={gwacheon} /> :
        type === 'namyangju' ? <BG width={710} height={2528} imgUrl={namyangju} /> :
        type === 'sejong' ? <BG width={710} height={2528} imgUrl={sejong} /> :
        type === 'suwon' ? <BG width={710} height={2528} imgUrl={suwon} /> :
        type === 'sillim' ? <BG width={710} height={2528} imgUrl={sillim} /> :
        type === 'yangyang' ?<BG width={710} height={2528} imgUrl={yangyang} /> :
        type === 'yeosu' ? <BG width={710} height={2528} imgUrl={yeosu} /> :
        type === 'yeouido' ? <BG width={710} height={2528} imgUrl={yeouido} /> :
        type === 'yongin' ? <BG width={710} height={2528} imgUrl={yongin} /> :
        type === 'incheon' ? <BG width={710} height={2528} imgUrl={incheon} /> :
        type === 'jeju' ? <BG width={710} height={2528} imgUrl={jeju} /> :
        type === 'cheonan' ? <BG width={710} height={2528} imgUrl={cheonan} /> :
        type === 'pajuh' ? <BG width={710} height={2528} imgUrl={pajuh} /> :
        type === 'haeundae' ?<BG width={710} height={2528} imgUrl={haeundae} /> :
        type === 'hongdae' ? <BG width={710} height={2528} imgUrl={hongdae} /> :
        null
      }
      <button className="re-try" onClick={clickReTry} />
      <button className="copy" onClick={clickCopy} />
      <button className="kakao" onClick={sendLink} />
      <button className="search" onClick={clickSearchRoom} />
    </ResultWrap>
  );
}

export default ResultComponent;
